function setIndentAfterOpenModule(module) {
	[...document.querySelectorAll('.vg-' + module)].forEach(el => {
		el.addEventListener('vg.'+ module +'.show', function () {
			showModule();
		});
		el.addEventListener('vg.'+ module +'.hide', function () {
			hideModule();
		});
	});

	function showModule() {
		let indent = (window.innerWidth - document.documentElement.clientWidth) + 'px',
			headerTop = document.querySelector('.vg-hdr-top'),
			headerBottom = document.querySelector('main');

		if (indent === '0px') return;

		if (headerTop) headerTop.style.paddingRight = indent;
		if (headerBottom) headerBottom.style.paddingRight = indent;
	}

	function hideModule() {
		let headerTop = document.querySelector('.vg-hdr-top'),
			headerBottom = document.querySelector('main');

		if (headerTop) headerTop.style.paddingRight = '';
		if (headerBottom) headerBottom.style.paddingRight = '';
	}
}

export default setIndentAfterOpenModule;
